import { Vue } from 'vue-property-decorator'
import debounce from 'lodash.debounce'
import { Evaluators, Rules } from '@/components/common/inputs/types'
import * as ruleNames from '@/components/common/inputs/constants/ruleNames'
import { getErrorMessage } from './utils'
import { ErrorObject, ErrorMessages, DisplayFieldNames } from './types'

export default class Validator {
  readonly evaluators: Evaluators = {}
  readonly notificationDelay = 1000
  readonly errors: ErrorObject = {}
  readonly messages: ErrorMessages = {}
  readonly displayNames: DisplayFieldNames = {}

  validateResult = true

  evaluate(isOnlyDirty = true) {
    const evaluators = this.evaluators

    Object.keys(evaluators).forEach(name => {
      if (isOnlyDirty && !evaluators[name].$dirty) {
        return
      }

      Vue.set(this.errors, name, this.extractError(evaluators[name]))
      Vue.set(
        this.messages,
        name,
        this.errors[name] ? this.getErrorMessage(name) : ''
      )
    })
  }

  // 通知を受け取る場合は、Form.isValidationNotify=trueにオーバーライドする
  handleValidate(wait = this.notificationDelay) {
    debounce(() => this.evaluate(), wait)()
  }

  hasAnyError(isOnlyDirty = false) {
    this.evaluate(isOnlyDirty)

    const evaluators = this.evaluators

    this.validateResult = !Object.keys(evaluators).some(name => {
      return this.errors[name]
    })

    return !this.validateResult
  }

  getFirstErrorMessage() {
    const name = Object.keys(this.messages).find(
      name => this.messages[name] != ''
    )

    if (!name) {
      return ''
    }

    return this.messages[name]
  }

  getErrorMessage(name?: string): string {
    if (!name) {
      return getErrorMessage('', {})
    }

    const rules = this.evaluators[name]

    if (!rules) {
      return getErrorMessage('', {})
    }

    if (rules instanceof Validator) {
      const fieldName = Object.keys(rules.errors).find(
        name => rules.errors[name]
      )
      if (!fieldName) {
        return ''
      }

      return rules.getErrorMessage(fieldName || '')
    }

    const ruleName = this.getRuleSet(rules).find(name => !rules[name]) as
      | string
      | undefined

    if (ruleName === undefined) {
      return ''
    }

    const displayName = this.displayNames[name]

    return displayName
      ? `${displayName}は${getErrorMessage(ruleName, rules.$params[ruleName])}`
      : getErrorMessage(ruleName, rules.$params[ruleName])
  }

  getRuleSet(rules: Rules) {
    return Object.values(ruleNames).filter(key => key in rules)
  }

  extractError(rules?: Rules | Validator) {
    if (rules instanceof Validator) {
      return rules.hasAnyError()
    }

    if (!rules) {
      return false
    }

    return this.getRuleSet(rules).some(name => !rules[name])
  }
}
